<div class="main-filters-cont">
  <ng-container *ngFor="let mainFilterItem of currentMainFilterItems; let last = last">
    <ng-container
      *ngIf="!mainFilterItem.groups || (mainFilterItem.groups && mainFilterItem.groups.indexOf(selectedGroup) >= 0)">
      <div class="main-filter-item" [hidden]="mainFilterItem.hidden || mainFilterItem?.options?.length <= 0">
        <div class="main-filter-item-label d-none">{{mainFilterItem?.label}}:</div>
        <ng-container *ngIf="mainFilterItem?.type === 'toggle-filter'">
          <ng-container *ngTemplateOutlet="toggleOption; context: {$implicit: mainFilterItem}"></ng-container>
        </ng-container>

        <ng-container *ngIf="mainFilterItem?.type === 'dropdown-toggle-filter'">
          <div class="d-none d-md-block">
            <ng-container *ngTemplateOutlet="toggleOption; context: {$implicit: mainFilterItem}"></ng-container>
          </div>
          <div class="d-md-none">
            <ng-container *ngTemplateOutlet="dropdownOption; context: {$implicit: mainFilterItem}"></ng-container>
          </div>
        </ng-container>

        <ng-container *ngIf="!mainFilterItem?.type">
          <ng-container *ngTemplateOutlet="dropdownOption; context: {$implicit: mainFilterItem}"></ng-container>
        </ng-container>

      </div>
    </ng-container>
  </ng-container>
</div>

<ng-template #toggleOption let-mainFilterItem>
  <div aria-label="Basic example" class="btn-group toggle-filter insight-toggle-filter" role="group">
    <ng-container *ngFor="let option of mainFilterItem?.options">
      <button class="btn btn-secondary" (click)="selectMainFilter(mainFilterItem,option)"
        [ngClass]="{ active: mainFilterItem.selected.value === option.value }" type="button">
        <span [innerHTML]="option.label | safehtml"></span>
        <span class="ml-1" *ngIf="mainFilterItem.showCount && option.count">({{ option.count | roundsig
          }})</span>
      </button>
    </ng-container>
  </div>
</ng-template>

<ng-template #dropdownOption let-mainFilterItem>
  <button class="btn btn-secondary text-capitalize" [hidden]="mainFilterItem?.options?.length > 0"
    [innerHTML]="mainFilterItem?.selected?.label">
  </button>
  <div class="dropdown filter-dropdown" [hidden]="mainFilterItem?.options?.length <= 0">
    <button class="btn btn-secondary dropdown-toggle text-capitalize" type="button" id="dropdownMenuButton"
      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
      [ngClass]="{disabled: mainFilterItem?.options?.length < 2}"
      (click)="selectedMainFilterItemClick(mainFilterItem, $event)">
      <span [innerHTML]="mainFilterItem?.selected?.label | safehtml"></span>
      <span class="ml-2" *ngIf="mainFilterItem.showCount && mainFilterItem?.selected?.count">({{
        mainFilterItem?.selected?.count | roundsig
        }})</span>
    </button>
    <div class="filter-dropdown-tooltip" *ngIf="mainFilterItem?.tooltip && mainFilterItem?.showTooltip">
      {{mainFilterItem?.tooltip}}
      <i class="fa fa-caret-down"></i>
    </div>
    <div class="dropdown-menu" [ngClass]="{'dropdown-menu-right last': last}" aria-labelledby="dropdownMenuButton"
      #dropdownMenu>
      <ng-container *ngIf="mainFilterItem?.options?.length > 10">
        <div class="input-group">
          <span class="input-group-addon" id="search-country">
            <i class="fa fa-search"></i>
          </span>
          <input class="form-control" placeholder="Search..." type="text" [attr.id]="'search-input-'+mainFilterItem.key"
            [(ngModel)]="mainFilterItem.searchText" (keydown.enter)="onSearchEnter(mainFilterItem)"
            (ngModelChange)="onSearchChange(mainFilterItem)">
        </div>
      </ng-container>
      <div class="dropdown-menu-items">
        <ng-container *ngFor="let option of mainFilterItem?.options">
          <ng-container *ngIf="!option?.hidden">
            <div class="d-flex align-items-center dropdown-item text-capitalize"
              [ngClass]="{'text-nowrap': mainFilterItem.showCount, 'disabled': option.disabled}"
              (click)="selectMainFilter(mainFilterItem,option)">
              <a [innerHTML]="option?.label | safehtml">
                {{option?.label}}
              </a>
              <span class="count px-2" *ngIf="mainFilterItem.showCount && option.count">({{ option.count |
                roundsig
                }})</span>
              <i *ngIf="mainFilterItem.selected.value === option.value" class="fa fa-check ml-auto"></i>
            </div>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="mainFilterItem.showNoResults">
          <div class="dropdown-item">No results found.</div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>